<template>
    <main class="m-composable-ai">
        <y-container>
            <y-hero
                class="m-composable-ai__hero"
                @hero-content="getHeroContent"
            />
        </y-container>

        <div class="m-composable-ai__benefits-slider">
            <div class="m-composable-ai__slider-wrapper--hidden">
                <y-container v-if="heroContent">
                    <y-in-action-slider :content="heroContent" />
                </y-container>
            </div>
        </div>

        <div class="m-composable-ai__features">
            <y-container>
                <y-features @visual-content="getVisualContent" />
            </y-container>
        </div>

        <div
            v-if="visualContent"
            class="m-composable-ai__video"
        >
            <y-container>
                <h2 class="m-composable-ai__video-title">
                    {{ visualContent.custom.field1 }}
                </h2>
                <y-visualizing :content="visualContent" />
            </y-container>
        </div>

        <div v-if="visualContent">
            <y-container>
                <y-use-cases :content="visualContent" />
            </y-container>
        </div>

        <div class="m-composable-ai__integrate">
            <y-container>
                <y-integrate />
            </y-container>
        </div>
    </main>
</template>

<script >
    import PageMixin from '@groot-nodes/mixins/Page.js';
    import YHero from '@modules/composable-ai/components/Hero/Hero.vue';
    import YFeatures from '@modules/composable-ai/components/Features/Features.vue';
    import YVisualizing from '@modules/composable-ai/components/Visualizing/Visualizing.vue';
    import YUseCases from '@modules/composable-ai/components/UseCases/Index.vue';
    import YInActionSlider from '@modules/api/components/InActionSlider/InActionSlider.vue';
    import YIntegrate from '@modules/composable-ai/components/Integrate/Integrate.vue';

    // Helper
    import { removeSymbol } from '@/helpers/helpers';

    export default {
        name: 'ComposablePage',

        components: {
            YHero,
            YFeatures,
            YVisualizing,
            YUseCases,
            YInActionSlider,
            YIntegrate,
        },

        mixins: [PageMixin],

        /**
         * @inheritdoc
         */
        data() {
            return {
                heroContent  : '',
                visualContent: '',
            };
        },

        /**
         *
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.heroContent.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.heroContent.seo_meta_description,
                    },
                ],
            };
        },

        methods: {
            removeSymbol,

            /**
             * get Hero content
             *
             * @param {object} value
             */
            getHeroContent(value) {
                this.heroContent = value;
            },

            /**
             * get visualisaztion content
             *
             * @param {object} value
             */
            getVisualContent(value) {
                this.visualContent = value;
            },
        },
    };

</script>

<style lang="scss" src="../scss/composable.scss"/>
